const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaCidade: [],
    listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'UNIDADE_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'UNIDADE_LISTADO':
            return {
                ...state,
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.nome,
                    latitude: item.latitude,
                    longitude: item.longitude
                }))
            };

        case 'UNIDADE_CIDADE_SELECT_LISTADO':
			return {
				...state,
				listaCidade: action.payload.data
			};

        default:
            return state;
    }
}
